import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function SolutionSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <div ref={ref} className="w-full px-6 pt-32 pb-20 bg-gradient-to-b from-slate-900/30 via-slate-900/50 to-slate-900/40 relative" data-id="element-188">
      {/* Chapter indicator */}
      <motion.div initial={{
      opacity: 0,
      x: -50
    }} animate={inView ? {
      opacity: 1,
      x: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto mb-12" data-id="element-189">
        <div className="flex items-center gap-6 mb-8" data-id="element-190">
          <div className="text-8xl font-bold text-cyan-500/20" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-191">
            02
          </div>
          <div data-id="element-192">
            <p className="text-sm text-purple-400 font-semibold tracking-wider uppercase mb-2" data-id="element-193">
              Chapter Two
            </p>
            <h2 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent" style={{
            fontFamily: 'Oswald, sans-serif',
            textShadow: '0 0 40px rgba(34, 211, 238, 0.3)'
          }} data-id="element-194">
              The Path Forward
            </h2>
          </div>
        </div>
      </motion.div>
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="space-y-8 text-lg text-gray-300 leading-relaxed font-light" data-id="element-196">
          <p className="text-2xl font-medium text-white text-center" data-id="element-197">
            Because your job is not to "manage" your health problems.
          </p>
          <div className="relative py-6" data-id="element-198">
            <p className="text-3xl md:text-4xl font-bold text-center bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent" style={{
            fontFamily: 'Oswald, sans-serif',
            textShadow: '0 0 50px rgba(139, 92, 246, 0.4)'
          }} data-id="element-199">
              Your job is to make it so you don't have health problems.
            </p>
            <motion.div initial={{
            scaleX: 0
          }} animate={inView ? {
            scaleX: 1
          } : {}} transition={{
            delay: 0.6,
            duration: 0.8
          }} className="h-1 w-64 mx-auto mt-4 bg-gradient-to-r from-purple-500 via-cyan-500 to-purple-500 rounded-full shadow-lg shadow-cyan-500/50" data-id="element-200" />
          </div>
          <p data-id="element-201">
            This requires help from a true MASTER of health and human biology.
            And it's exactly what our full transformation programs are about.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={inView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.7,
        duration: 0.8
      }} data-id="element-202">
          <TestimonialCard text="I've gone from thinking about my funeral to planning hiking trips. I can't thank you guys and the team enough." highlight={true} profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/qbpR2t1fKurWy6xZQHUkqR/Screenshot_2025-11-10_201556.png" name="Tony R." data-id="element-203" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.9,
        duration: 0.8
      }} className="bg-slate-900/60 border-2 border-purple-500/30 rounded-xl p-10 space-y-6 shadow-2xl shadow-purple-500/20" data-id="element-204">
          <p className="text-lg text-gray-300 font-light" data-id="element-205">
            Our full hands-on transformation programs can be a big investment,
            ranging from{' '}
            <span className="text-cyan-400 font-semibold" data-id="element-206">
              $15,000 to $40,000
            </span>{' '}
            and even{' '}
            <span className="text-cyan-400 font-semibold" data-id="element-207">$120,000</span> for
            our highest tier. Many of our clients will tell you it's the best
            investment they've ever made.
          </p>
          <p className="text-2xl font-medium text-white text-center" data-id="element-208">
            But would this be right for you?
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 1.1,
        duration: 0.8
      }} className="space-y-8 text-lg text-gray-300 leading-relaxed font-light" data-id="element-209">
          <p className="text-xl font-medium text-cyan-400 text-center" data-id="element-210">
            Maybe you simply need, most of all, to be shown exactly what to do.
          </p>
          <div className="bg-gradient-to-br from-purple-900/40 via-cyan-900/30 to-purple-900/40 border-2 border-cyan-500/40 rounded-2xl p-12 my-12 shadow-2xl shadow-cyan-500/20 relative overflow-hidden" data-id="element-211">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 to-cyan-600/10 blur-3xl" data-id="element-212" />
            <div className="relative space-y-6" data-id="element-213">
              <p className="text-xl mb-6 text-center" data-id="element-214">
                Because at the end of the day, this isn't really about peptides.
                This is about you.
              </p>
              <div className="space-y-3 text-center" data-id="element-215">
                <p className="text-2xl font-medium text-white" data-id="element-216">Your brain.</p>
                <p className="text-2xl font-medium text-white" data-id="element-217">Your body.</p>
                <p className="text-2xl font-medium text-white" data-id="element-218">Your life.</p>
                <motion.p initial={{
                scale: 1
              }} animate={{
                scale: [1, 1.1, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                repeatDelay: 3
              }} className="text-4xl md:text-5xl text-cyan-400 font-bold pt-4" style={{
                fontFamily: 'Oswald, sans-serif',
                textShadow: '0 0 40px rgba(34, 211, 238, 0.6)'
              }} data-id="element-219">
                  You.
                </motion.p>
              </div>
              <p className="text-xl mt-8 text-gray-300 font-light text-center" data-id="element-220">
                This is where the magic is.
              </p>
            </div>
          </div>
          <p data-id="element-221">
            This intense focus and attention to even the tiniest details about
            YOUR unique situation.
          </p>
          <p data-id="element-222">
            This precise approach to rebuilding YOUR biology from the ground up.
          </p>
          <p className="text-2xl font-semibold text-white text-center" data-id="element-223">
            All from a true master of healing & enhancing human biology.
          </p>
          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 1.3,
          duration: 0.8
        }} className="flex justify-center pt-8" data-id="element-224">
            <a href="https://go.peptidescienceinstitute.com/mwm" className="px-10 py-5 bg-gradient-to-r from-purple-600 to-cyan-600 text-white text-xl font-bold rounded-lg hover:from-purple-500 hover:to-cyan-500 transition-all shadow-2xl shadow-purple-500/50 hover:shadow-purple-500/70" data-id="element-225">
              Book Your Meeting
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>;
}